import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {getNorthCitiesIds} from "@models/area";
import 'react-lazy-load-image-component/src/effects/blur.css';
import RadiusGenerate from "@helpers/radius.generate";
import {Image, Time, FooterContainer as ImageFooterContainer, Footer as ImageFooter, VideoIframeCard} from "./components/card.image";
import ConvertPixelToRem from "@helpers/convert.rem";
import {Address, Details, PriceContainer} from "./components/card.info";
import {handleTitle, handlePropertyPrice, handlePropertyFeatures} from "@organisms/property/helpers/property_helpers";
import useTrans from "@hooks/translation";
import {getThumbnailPath, getVillaTypes} from "@models/property";
import {isEmpty, time_ago} from "@helpers/helpers";
import {inArray} from "@helpers/arrays";
import {getPropertyUrl, getPropertyVideoPath} from "./helpers/property_helpers";
import MediaItems from "./components/media_items";


function CardFull({property, className, handleShowProperty, selectedCityId = null, isBadeSaba = false}) {
    const {media, deal_type} = property;
    const [northCitiesIds, setNorthCitiesIds] = useState([]);
    const pricing = handlePropertyPrice(property, false, northCitiesIds);
    const videoPath = getPropertyVideoPath(property);

    let imgCount = 0, videoCount = 0;
    if (!isEmpty(media) && media.length) {
        for (let item of media) {
            if (item.type === 'video') {
                videoCount += 1;
            } else {
                imgCount += 1;
            }
        }
    }

    useEffect(() => {
        if (!northCitiesIds.length) {
            getNorthCitiesIds().then(ids => {
                setNorthCitiesIds(ids);
            })
        }
    }, []);

    return (
        <Figure className={className ?? ''}>
            <CustomTag
                is_link={isEmpty(videoPath)}
                getPropertyUrl={getPropertyUrl}
                property={property}
                isBadeSaba={isBadeSaba}
                handleShowProperty={handleShowProperty}
            >
                <ImageCard>
                    <Image>
                        {
                            (videoPath && !isEmpty(property) && !property.archived) ?
                                <VideoIframeCard className="">
                                    <span style={{display: 'block', paddingTop: '57%'}}/>
                                    <iframe src={videoPath} allowFullScreen="true" webkitallowfullscreen="true"
                                            mozallowfullscreen="true"/>
                                </VideoIframeCard>
                                :
                                <LazyLoadImage
                                    src={getThumbnailPath(property)}
                                    effect="blur"
                                    height="100%"
                                    width="100%"
                                    alt={handleTitle(property, false, selectedCityId)}/>
                        }
                    </Image>

                    {
                        (!videoPath || property.archived) ?
                            <ImageFooterContainer className={((imgCount > 0) ? 'has-media' : '')}>
                                <ImageFooter className="d-flex justify-content-between align-items-center">
                                    <Time className={((imgCount > 0) ? 'text-white' : '')}>{time_ago(property.boosted_at, '6_month')}</Time>

                                    <div className="d-flex align-items-center media-box">
                                        <MediaItems img_count={imgCount} video_count={videoCount}/>
                                    </div>
                                </ImageFooter>
                            </ImageFooterContainer>
                            : ''
                    }
                </ImageCard>
            </CustomTag>

            <figcaption className="p-0 m-0">
                <InfoCard>

                    {
                        (inArray(property.city_id, northCitiesIds)) ?
                            <TypeTitle className="d-block">{useTrans('type.' + property.type) + (!isEmpty(property.villa_type) ? (' ' + getVillaTypes(property.villa_type)) : '')}</TypeTitle>
                            : ''
                    }

                    <a href={getPropertyUrl(property, isBadeSaba)} onClick={(e) => handleShowProperty(e, getPropertyUrl(property, isBadeSaba), ((!isEmpty(property.media) && property.media.length) ? property.media.length : 0))}>
                        <h3 className="property-card-title">
                            <Address className="text-ellipsis">{handleTitle(property, false, selectedCityId)}</Address>
                        </h3>
                    </a>

                    {
                        (!inArray(property.city_id, northCitiesIds)) ?
                            <DetailsCard className="d-block">{handlePropertyFeatures(property, 3)}</DetailsCard>
                            : ''
                    }

                    <div className="text-right">

                        {
                            (pricing.length) ?
                                pricing.map(({price, label}, key) =>
                                    <Price className="d-flex align-items-center">
                                        <span className="h3">{price.num + ' ' + price.unit}</span>
                                        {
                                            (!isEmpty(label)) ?
                                                <span className="d-block mr-1 h3">{label}</span>
                                                : ''
                                        }
                                    </Price>
                                )

                                : ''
                        }
                    </div>
                </InfoCard>
            </figcaption>
        </Figure>
    )
}

export default React.memo(CardFull);

const CustomTag = ({is_link, getPropertyUrl, property, isBadeSaba, handleShowProperty, children}) => {

    if (is_link) {
        return (
            <a href={getPropertyUrl(property, isBadeSaba)}
               onClick={(e) => handleShowProperty(e, getPropertyUrl(property, isBadeSaba), ((!isEmpty(property.media) && property.media.length) ? property.media.length : 0))}>
                {children}
            </a>
        )
    } else {
        return (
            <div className="w-100 h-100 ">{children}</div>
        )
    }
}


// styles
export const DetailsCard = styled(Details)`
      @media (max-width: ${props => props.theme.screenSmMax}) {
            margin-top: 0;
      }
`;

const Figure = styled.figure`
    &:hover {
        
    }
`;

const TypeTitle = styled.span`
    font-size: ${props => props.theme.fontSizeBase};
    color: ${props => props.theme.gray400};
    font-weight: 300;
    line-height: 1.35;
`;

export const Price = styled(PriceContainer)`
    margin-top: 0;
`;
const InfoCard = styled.div`
    margin-top: 12px;
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        ${Address} {
            font-size: ${ConvertPixelToRem(16)};
            font-weight: 300;
            line-height: 1.44;
            color: #222222;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        
        ${Details} {
            margin-top: 4px !important;
            span {
                font-size: ${ConvertPixelToRem(14)};
                font-weight: 300;
                line-height: 1.64;
            }
        } 
        
        ${Price} {
            margin-top: 4px !important;
            .h3 {
                font-size: ${ConvertPixelToRem(15)};
                font-weight: bold;
                line-height: 1.4;
            }
        }
    }
`;

export const ImageCard = styled.div`
    position: relative;
    width: 100%;
    height: 190px;
    object-fit: contain;
    ${RadiusGenerate('4px')};
    
    @media (min-width: ${props => props.theme.screenXsMax}) and (max-width: ${props => props.theme.screenSmMax}) {
        height: 24vw !important;
    }
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        height: 40vw !important;
    }
    
    ${ImageFooterContainer} {
        border-radius: 0 0 8px 8px;
    }
`;

